module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-info",
    style: ({
      'height': _vm.deviceHeight
    })
  }, [_c('div', {
    staticClass: "edi-sendinfo-title"
  }, [_vm._v("送货信息维护")]), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('span', {
    staticClass: "ui-col-3"
  }, [_vm._v("送货人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "ui-col-7",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ui-col-3"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "ui-col-7",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ui-col-3"
  }, [_vm._v("车牌号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carNum),
      expression: "carNum"
    }],
    staticClass: "ui-col-7",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.carNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carNum = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup",
    staticStyle: {
      "padding": "0 .5em"
    }
  }, [_c('input', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "value": "保存修改"
    },
    on: {
      "click": _vm.modifySave
    }
  })]), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsTwoShow),
      expression: "tipsTwoShow"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.tipsTwoShow, 'tips-end': !_vm.tipsTwoShow
    }
  }, [_c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.elseTipsFont))])]), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-marbot red-font",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveReturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[0]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn tips-marbot",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.quitRuturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[1]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[2]))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05c67c6b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SendInfo.vue
// module id = 528
// module chunks = 1